<template>
    <section class="bg-white py-16 sm:py-24">
        <Container>
            <div class="mx-auto max-w-3xl">
                <SectionHeading eyebrow="FAQs" title="Looking for answers?" align="center" />

                <div class="mt-12 space-y-4">
                    <div v-for="faq in faqs" :key="faq.id"
                        :class="['overflow-hidden rounded-2xl border transition-colors', faq.active ? 'border-primary-200 bg-primary-50/40' : 'border-gray-100']"
                        :id="`basic-heading-${faq.id}`">
                        <button
                            class="accordion-toggle flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors"
                            :aria-controls="`basic-collapse-${faq.id}`" :aria-expanded="faq.active"
                            @click="toggleAccordion(faq)">
                            <span :class="['text-base font-semibold', faq.active ? 'text-primary-700' : 'text-gray-900']">
                                {{ faq.question }}
                            </span>
                            <span
                                :class="['flex size-8 shrink-0 items-center justify-center rounded-full transition-colors', faq.active ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-500']">
                                <PlusIcon v-if="!faq.active" class="size-4" />
                                <MinusIcon v-else class="size-4" />
                            </span>
                        </button>
                        <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave"
                            @leave="leave">
                            <div :id="`basic-collapse-${faq.id}`" v-show="faq.active" class="overflow-hidden px-6"
                                :aria-labelledby="`basic-heading-${faq.id}`">
                                <p class="pb-6 text-sm/6 text-gray-600">{{ faq.answer }}</p>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </Container>
    </section>
</template>

<script setup type="module">

import { ref } from 'vue';
import { PlusIcon, MinusIcon } from '@heroicons/vue/24/outline';
import Container from '@/components/ui/Container.vue';
import SectionHeading from '@/components/ui/SectionHeading.vue';
import { getFaqs } from '@/services/faqService';

const faqs = ref([]);

const fetchFaqs = async () => {
    try {
        const response = await getFaqs();
        faqs.value = response.data;
    } catch (error) {
        console.error('Error fetching FAQs:', error);
    }
};

fetchFaqs();

const toggleAccordion = (faq) => {
    faqs.value.forEach((item) => {
        item.active = item.id === faq.id ? !item.active : false;
    });
};

// Transition hooks for height animation
const beforeEnter = (el) => {
    el.style.height = '0';
};

const enter = (el) => {
    el.style.transition = 'height 0.3s ease';
    el.style.height = el.scrollHeight + 'px';
};

const beforeLeave = (el) => {
    el.style.height = el.scrollHeight + 'px';
};

const leave = (el) => {
    el.style.transition = 'height 0.3s ease';
    el.offsetHeight; // force reflow
    el.style.height = '0';
};

</script>
